<template>
  <div class="vip-page">
    <top-bar :topbarList="vipTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";
import { mapState } from "vuex";
import { vipIndexMixins } from "@/mixins/vipIndexMixins";

export default {
  mixins: [vipIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.vip-page {
  height: 100%;
}
</style>
